// export const getUsers = async (): Promise<AxiosResponse<User, any>> =>
//   await api.get(endpoints.users);

import { endpoints } from "constant";
import { api } from "./http";

export const getUsers = (): Promise<{
  data: any;
}> => api.get(endpoints.analytics);
